window.init_main = function() {
    jQuery('form').submit(function() {
        jQuery(this).find(':submit').prop('disabled', 'true');
        setTimeout(jQuery.proxy(function() {
            jQuery(this).find(':submit').prop('disabled', '');
        }, 3000), this);
    });


    //フォームには使用できない
    jQuery('button.timeout-onclick-btn').click(function() {
        jQuery(this).prop('disabled', 'true');
        setTimeout(jQuery.proxy(function() {
            jQuery(this).prop('disabled', '');
        }, 3000), this);
    });

}

jQuery(document).ready(function() {
    window.init_main();
});